module.exports = __webpack_public_path__ + "img/armenia.ed9d104f.png";